import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { fontBody, fontTitle } from 'Styles/fonts';
import { black, grey20, grey60 } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';
import Icon from '../Icons/Icon';

export const Footer = styled.div`
  width: 100%;
  background-color: ${grey20};
`;

export const LowerGrid = styled.div`
  display: grid;
  background-color: ${grey20};
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
  grid-row-gap: 0;
  padding: 0 16px;
  max-width: 1520px;
  position: relative;
  margin: 0 auto;

  ${breakpoint('medium')} {
    grid-template-rows: auto 1fr;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 24px;
    grid-row-gap: 0;
    padding: 0 24px;
  }
`;

export const Bottom = styled.div`
  background-color: ${grey20};
  grid-column: 1 / 3;

  ${breakpoint('medium')} {
    grid-column: 1 / 13;
  }
`;

export const HappinessContainer = styled.div`
  border-bottom: 1px solid ${grey60};
  margin: 58px 0 0 0;
  padding-bottom: 48px;
  grid-row: 3;
  grid-column: 1 / 3;

  ${breakpoint('medium')} {
    grid-row: 3 / 4;
    grid-column: 2 / 7;
    border-bottom: none;
    padding: 0;
  }
`;

export const Divider = styled.div`
  ${breakpoint('medium')} {
    border-right: 1px solid ${grey60};
    width: 1px;
    height: 304px;
    grid-column: 7;
    grid-row: 3 / 5;
    margin: 58px 0 0 0;
  }
`;

export const HappinessIcon = styled(Icon)`
  font-size: 36px;
  color: ${black};
  padding-bottom: 15.6px;
`;

export const HappinessBody = styled.p`
  ${fontBody(14)};
  max-width: 625px;
  color: ${black};
  margin: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 0 16px 0;
  gap: 8px;
`;

export const PhoneContainer = styled.p`
  ${fontBody(14)};
  color: ${black};
  margin: 0;
`;

export const PhoneNumber = styled.a`
  color: ${black};

  &:visited {
    color: ${black};
  }
`;

export const LinksContainer = styled.div`
  grid-row: 4;
  padding: 48px 0 48px 0;
  min-width: 0;

  ${ifProp(
    { length: 2 },
    `grid-column: ${ifProp({ column: 0 }, '1', '2')};`,
    'grid-column: 1;'
  )};

  ${breakpoint('medium')} {
    grid-row: 3;
    margin: 58px 0 20px 0;
    padding: 0;

    ${ifProp({ column: 0 }, 'grid-column: 8 / 10;', 'grid-column: 10 / 12;')};
  }
`;

export const BCorpContainer = styled.div`
  ${ifProp(
    { categorizedLinks: 2 },
    // if there are two CategorizedLinks components
    `color: ${black};
    grid-row: 5;
    grid-column: 1 / 3;
    display: inline-flex;
    padding: 0 0 48px 0;
    min-width: 0;

    ${breakpoint('medium')} {
      grid-row: 4;
      grid-column: 8 / 12;
      padding: 0;
    }`,
    // if there is only one CategorizedLinks component
    `color: ${black};
    grid-row: 4;
    grid-column: 2 / 3;
    color: ${black};
    padding: 48px 18.5px 0 0;
    min-width: 0;

    ${breakpoint('medium')} {
      margin-top: 58px;
      grid-row: 3;
      grid-column: 10 / 12;
      color: ${black};
      padding: 0;
    }`
  )}
`;

export const BCorpIcon = styled(Icon)`
  font-size: 96px;
  width: 64px;
  height: 96px;
  line-height: 96px;
`;

export const BCorpText = styled.p`
  ${fontTitle(14)};
  max-width: 200px;
  width: 170px;

  ${ifProp(
    { categorizedLinks: 2 },
    `float: right;
    padding-left: 16px;
    margin-top: 6px;
    width: 190px;
    `
  )}

  ${breakpoint('medium')} {
    height: 36px;
    width: 170px;
    ${ifProp({ categorizedLinks: 2 }, 'width: 190px;')}
  }
`;

export const BCorpLink = styled.a`
  ${fontBody(14)};
  color: ${black};

  &:visited {
    color: ${black};
  }
`;

export const LegalContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${ifProp({ categorizedLinks: 2 }, 'grid-row: 7;', 'grid-row: 6;')}
  grid-column: 1 / 3;
  border-top: 1px solid ${grey60};
  border-bottom: 1px solid ${grey60};
  padding: 18px 0;
  gap: 16px;

  ${breakpoint('medium')} {
    grid-row: 6;
    grid-column: 2 / 12;
    margin: 64px 0 0 0;
  }

  ${breakpoint('large')} {
    flex-direction: column;
  }
`;

export const LegalLinks = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${breakpoint('medium')} {
    flex-direction: row;
  }
`;

export const LegalLink = styled.a`
  text-decoration: none;
  ${fontBody(12)};
  color: ${black};
  margin-bottom: 16px;

  &:hover {
    text-decoration: underline;
  }

  &:last-of-type {
    margin-right: 0;
    margin-bottom: 0;
  }

  &:visited {
    color: ${black};
  }

  ${breakpoint('medium')} {
    margin-right: 16px;
    margin-bottom: 0;
  }
`;

export const Notice = styled.div`
  ${ifProp({ categorizedLinks: 2 }, 'grid-row: 8;', 'grid-row: 7;')}
  grid-column: 1 / 3;
  padding-top: 25px;
  padding-bottom: 25px;
  height: 100%;

  ${breakpoint('medium')} {
    grid-row: 7;
    grid-column: 2 / 12;
  }
`;

export const NoticeMessage = styled.span`
  ${fontBody(12)};
  color: ${black};
`;

export const NoticeTitle = styled.strong`
  ${fontBody(12)};
  font-weight: 900;
  color: ${black};
`;

export const NoticePrivacyLink = styled.a`
  ${fontBody(12)};
  color: ${black};
  white-space: nowrap;
  &:visited {
    color: ${black};
  }

  ${breakpoint('medium')} {
    height: 15px;
    width: auto;
  }
`;
